import type { CustomComponents, DateRange, PropsBase } from "react-day-picker";
import { DayPicker } from "react-day-picker";

import { useCustomLocale } from "@ui/components/DatePicker/hooks/useCustomLocale/useCustomLocale";
import classNames from "classnames";

import { Chevron } from "../Chevron/Chevron";
import { MonthCaption } from "../MonthCaption/MonthCaption";

import "react-day-picker/style.css";
import styles from "./Calendar.module.scss";
import datePickerStyles from "@ui/components/DatePicker/DatePicker.module.scss";

const components: Partial<CustomComponents> = {
  MonthCaption: MonthCaption,
  Chevron: Chevron,
};

type CalendarProps = Omit<PropsBase, "mode"> & {
  mode: "range";
  selected?: DateRange;
  onSelect?: (range: DateRange | undefined) => void;
  min?: number;
  max?: number;
};

export const Calendar = (props: CalendarProps) => {
  const customLocale = useCustomLocale();
  const className = classNames(datePickerStyles.datePicker, styles.datePicker, "light-theme");
  const numberOfMonths = props.numberOfMonths ?? 2;

  return (
    <DayPicker
      mode="range"
      className={className}
      locale={customLocale}
      selected={props.selected}
      onSelect={props.onSelect}
      min={props.min}
      max={props.max}
      numberOfMonths={numberOfMonths}
      defaultMonth={props.defaultMonth ?? new Date()}
      today={props.today}
      disabled={props.disabled}
      components={components}
    />
  );
};
